/**
 * @generated SignedSource<<08cb9121194f7a752ccf3a89937f1dac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SignUrlPayload",
    "kind": "LinkedField",
    "name": "signUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationHistoryQuery_signUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConversationHistoryQuery_signUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1d820402276d658783d94e76be369402",
    "id": null,
    "metadata": {},
    "name": "ConversationHistoryQuery_signUrlMutation",
    "operationKind": "mutation",
    "text": "mutation ConversationHistoryQuery_signUrlMutation(\n  $input: SignUrlInput!\n) {\n  signUrl(input: $input) {\n    signUrl\n  }\n}\n"
  }
};
})();

node.hash = "945ede68b74b13c9e2c32788ba7b68c3";

module.exports = node;
